export default __webpack_public_path__ + "locales/pl/FillPDFDialog.json?hash=fd0a2fea3cf38b801da32a4634821473";